/* ============================================================
   FantasyDice Cards — Corner Marks + Fantasy Labels
   Duplicate theme only — NOT published
   ============================================================ */

(function () {
  'use strict';

  var LABELS = [
    '✶ Rare Relic',
    '✶ Hoard Treasure',
    '✶ Epic Artifact',
    '✶ Dragon\'s Pick',
    '✶ Rare Relic',
    '✶ Featured Item',
    '✶ Epic Artifact',
    '✶ Hoard Treasure'
  ];

  /* Inject four corner mark spans into every product card */
  function injectCorners() {
    document.querySelectorAll('.card.card--product').forEach(function (card) {
      if (card.querySelector('.fd-corners')) return;
      var wrap = document.createElement('div');
      wrap.className = 'fd-corners';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.innerHTML =
        '<span class="fd-corner fd-corner--tl"></span>' +
        '<span class="fd-corner fd-corner--tr"></span>' +
        '<span class="fd-corner fd-corner--bl"></span>' +
        '<span class="fd-corner fd-corner--br"></span>';
      card.appendChild(wrap);
    });
  }

  /* Inject small fantasy labels in featured-collection cards */
  function injectLabels() {
    var section = document.querySelector('.featured-collection');
    if (!section) return;

    section.querySelectorAll('.card__information').forEach(function (info, i) {
      if (info.querySelector('.fd-card-label')) return;
      /* Skip cards that already carry a sale badge — avoid double-labelling */
      var card = info.closest('.card');
      if (card && card.querySelector('.card__badge .badge')) return;

      var lbl = document.createElement('span');
      lbl.className = 'fd-card-label';
      lbl.textContent = LABELS[i % LABELS.length];
      info.insertBefore(lbl, info.firstChild);
    });
  }

  function init() {
    injectCorners();
    injectLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
